import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReportFormFieldModule } from '../../report-form-field/report-form-field.module';
import { ReportDetailDialogComponent } from './report-detail-dialog.component';
import { RequiresPermissionsModule } from '../../directives/requires-permissions/requires-permissions.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    ReportFormFieldModule,
    MatRadioModule,
    RequiresPermissionsModule
  ],
  exports: [ReportDetailDialogComponent],
  declarations: [ReportDetailDialogComponent]
})
export class ReportDetailDialogModule {}
